import React from "react";
import { Bar } from "react-chartjs-2";
import { configureChartFont } from "../../utils/chartFont";

const BarChart = ({ data: chartData }) => {
  configureChartFont();

  const data = {
    labels: chartData.map((l) => l.label),
    datasets: [
      {
        backgroundColor: chartData.map((l) => l.color),
        data: chartData.map((l) => l.value),
        borderColor: "white",
        borderWidth: 1,
      },
    ],
  };

  const options = {
    indexAxis: "y",
    xAxes: [
      {
        position: "left",
      },
    ],
    title: {
      display: false,
    },
    plugins: {
      legend: false,
    },
    responsive: true,
    maintainAspectRatio: false,
    borderRadius: 10,
    categoryPercentage: 0.5,
  };

  return <Bar data={data} options={options} />;
};

export default BarChart;
